import { useTranslation } from 'react-i18next'

import { PageEmptyState } from '../../PageEmptyState'

import DocFlowIcon from '../../../icons/doc-splitting.svg'

function DocFlowPhaseNotSupported() {
  const { t } = useTranslation()

  return (
    <PageEmptyState
      EntityIcon={DocFlowIcon}
      text={t('DocFlow.PhaseNotSupportedTextKey')}
    />
  )
}

export default DocFlowPhaseNotSupported
